<template>

  <v-container
    fill-height
    fluid
  >
      <v-overlay :absolute="false" :value="!iframe.loaded">
          <v-alert>CARREGANDO &nbsp;&nbsp; <v-progress-circular indeterminate></v-progress-circular></v-alert>
      </v-overlay>

    <v-row
      align="center"
      justify="center"
    >

      <v-col cols="12">

        <material-card
                color="primary"
        >
            <template v-slot:header>
                <div class="px-3">

                    <div class="title font-weight-bold mb-2">
                      Projetos e Ações de Ensino, Pesquisa e Extensão
                    </div>
                    <!--
                    <div class="category font-weight-thin">
                        Essa é uma informação importante
                        <a
                                class="white--text"
                                href="https://materialdesignicons.com/"
                                target="_blank"
                        >
                            clique aqui
                        </a>
                    </div>
                    -->
                </div>
            </template>
            <iframe :src="iframe.src" :width="iframe.width" :height="iframe.height" frameborder="0" ref="frameGrad" v-show="iframe.loaded" @load="loaded"></iframe>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
      components: {
          MaterialCard: () => import('../components/material/Card'),
          MaterialStatsCard: () => import('../components/material/StatsCard')
      },
      data: () => ({
          iframe: {
              //edit: https://app.powerbi.com/groups/3d3e6ad5-7f7d-463a-95b3-7c8056ccb21e/reports/b5c51dc9-c89f-475a-9550-387189b129cc/ReportSection096377e103a33ccb9a09
              src: 'https://app.powerbi.com/view?r=eyJrIjoiM2E1OWM1OTgtZmNkZS00ZWM2LTg0OWItMjIzNGU0ODcyNjExIiwidCI6Ijk4ZWY1ZDVkLTYzMGUtNDNjZC05OTE5LWY1MWNlMDQyYmU0YyJ9',
              loaded: false,
              height: null,
              width: '100%',
              originalWidth: 1280,
              originalHeight: 1930,
              autoResize: {
                  active: true,
                  timeout: 700,
                  timer: null
              },
          },
      }),
      mounted() {

      },
      beforeDestroy() {
          if(this.iframe.autoResize.timer) {
              clearInterval(this.iframe.autoResize.timer);
          }
      },
      methods: {
          loaded: function(){
              if(this.iframe.autoResize.active) {
                  this.iFrameResize();
                  this.iframe.autoResize.timer =
                      setInterval(this.iFrameResize, this.iframe.autoResize.timeout);
              }

              setTimeout(() => { this.iframe.loaded = true }, 1000); // delay
          },

          iFrameResize() {
              if(!this.$refs.frameGrad) {
                  return;
              }

              let parentWidth = this.$refs.frameGrad.parentElement.clientWidth;
              let ratio = this.iframe.originalHeight / this.iframe.originalWidth;
              this.iframe.height = parseInt(ratio * parentWidth) + 'px';
              this.iframe.width = '100%';
          }
      }
  }
</script>

<style lang="scss">
  .tim-note {
    bottom: 10px;
    color: #c0c1c2;
    display: block;
    font-weight: 400;
    font-size: 13px;
    line-height: 13px;
    left: 0;
    margin-left: 20px;
    width: 260px;
  }
</style>
